import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Onboarding'
      breadcrumbs={[
        {
          label: 'Onboarding',
        },
        {
          label: 'Onboarding',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/onboarding/onboarding',
  component: RouteComponent,
  type: 'auth',
});
